export default __webpack_public_path__ + "static/media/marker-gray-blue-yellow.ea1f0802.png";